module.exports = __webpack_public_path__ + "static/Image12@2x-4db24614d2ccd8447c2af2ea2f8cba35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image12@2x.jpg
// module id = 905
// module chunks = 227233210825294 244429959259914